import OrganizationFormI from "@interfaces/organization-formI";
import { generateUrl } from "@services/generateUrl/generateUrl";
import axiosApiInstance from "./custom-axios-instance";
import axios from "axios";
import drpServicesServiceApiInstance from "./clients/drproxservices";
//***** Interfaces *****
import OrganizationI, { 
    OfficeByOrganization,
    PractitionerByService, 
    PractitionerData, 
    PracttionerBasicInformation,
    IRequestPractitionersByOrganization
} from "@interfaces/organizationI";
import drProxPractitionerApiInstance from "./clients/drproxpractitioner";
import { IBasicCodeMessageResponse } from "@interfaces/api-basic-response";

/**
 * Register New organization at initial quiz level
 * @param organizationData {organizationName:string}
 * @return {OrganizationI} new organization registered
 */
export function saveOrganization(organizationData: OrganizationFormI) {
    return axiosApiInstance.post(
        `${generateUrl()}/organizationstructure/organization/`,
        organizationData
    ).then(data => {
        const organization = data.data as unknown;
        return organization as OrganizationI;
    });
}

interface IUpdateOrganizationTypeResponse
{
    code: string,
    message: string,
    response: string
}

export async function updateOrganizationType(organizationId: number, organizationTypeCode: string, name?: string) 
{
    const endpoint = `/organization/${organizationId}`;
    const data = {
        organizationTypeCode: organizationTypeCode,
        name: name
    };
    const response = await drpServicesServiceApiInstance.put<IUpdateOrganizationTypeResponse>(endpoint, data);
    return response.data;
}

// export function getPractitionersByOrganization(organizationId: number, searchTitle = '', page = 0, size = 100, timezone = 'UTC') {
//     return axiosApiInstance.get(
//         `${generateUrl()}/drprox/organization/practitioners/${organizationId}?page=${page}&searchTitle=${searchTitle}&size=${size}&timezone=${timezone}`,
//     ).then(data => {
//         const practitioners = data.data as unknown;
//         return practitioners as PractitionersByOrganization;
//     });
// }
export async function getPractitionersByOrganizationM(requestPractitionersByOrganization:IRequestPractitionersByOrganization) {
    let endpoint = `organization/practitioners/person/${requestPractitionersByOrganization.organizationId}`; 
    const params = new URLSearchParams();
    if(requestPractitionersByOrganization.page)
        params.append("page", String(requestPractitionersByOrganization.page));
    if(requestPractitionersByOrganization.searchTitle)
        params.append("searchTitle", String(requestPractitionersByOrganization.searchTitle));
    if(requestPractitionersByOrganization.size)
        params.append("size", String(requestPractitionersByOrganization.size));
    if(requestPractitionersByOrganization.timezone)
        params.append("timezone", String(requestPractitionersByOrganization.timezone));
    const strParams = params.toString();
    endpoint += `?${strParams}`;
    const response = await drProxPractitionerApiInstance.get<PracttionerBasicInformation[]>(endpoint);
    return response.data;
}

export function getPractitionersInformation(email: string, organizationId: number, timezone = "UTC") 
{
    return axiosApiInstance.get(
        `${generateUrl()}/drprox/organization/practitioner/person?email=${email}&organizationId=${organizationId}&timeZone=${timezone}`,
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as PracttionerBasicInformation;
    });
}

export function getPractitionersInformationKC(
    email: string, 
    organizationId: number, 
    timezone = "UTC", 
    token:string
    ) {
    return axios.get(
        `${generateUrl()}/drprox/organization/practitioner/person?email=${email}&organizationId=${organizationId}&timeZone=${timezone}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as PracttionerBasicInformation;
    });
}

export function postPractitioner(languageCode: string, organizationId: number, practitionerData: PracttionerBasicInformation, appOrigin: string) {
    return axiosApiInstance.post(
        `${generateUrl()}/drprox/organization/practitioner/${organizationId}?appOrigin=${appOrigin}&languageCode=${languageCode}`,
        practitionerData
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as PracttionerBasicInformation;
    });
}
export async function postPractitionerM(languageCode: string, organizationId: number, practitionerData: PracttionerBasicInformation, appOrigin: string) {
    const endpoint = `organization/practitioner/person/${organizationId}?appOrigin=${appOrigin}&languageCode=${languageCode}`; 
    const response = await drProxPractitionerApiInstance.post<PracttionerBasicInformation>(endpoint,practitionerData);
    return response.data;
}

export function editPractitioner(statusCode: string, organizationPractitionerContractId: number, roles: string[]) {
    return axiosApiInstance.put(
        `${generateUrl()}/drprox/organization/practitioner/${organizationPractitionerContractId}?statusCode=${statusCode}`,
        roles
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as IBasicCodeMessageResponse;
    });
}
export function editPractitionerKC(statusCode: string, organizationPractitionerContractId: number, roles: string[], token:string) {
    return axios.put(
        `${generateUrl()}/drprox/organization/practitioner/${organizationPractitionerContractId}?statusCode=${statusCode}`,
        roles,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as IBasicCodeMessageResponse;
    });
}

export async function editPractitionerM(organizationId: number | string, email:string, roles: string[], statusCode: string) 
{
    const endpoint = `organization/practitioner/${organizationId}/${email}?statusCode=${statusCode}`; 
    const response = await drProxPractitionerApiInstance.put<IBasicCodeMessageResponse>(endpoint, roles);
    return response.data;
}

/**
 * Send a request to activate current logged user in the organization
 * @param organizationId 
 * @returns Success code/message response
 * @throws If user has not been invited into the organization
 */
export async function activateCurrentPractitionerInOrganization(organizationId: number | string)
{
    const endpoint = `organization/practitioner/${organizationId}/activate`;
    const response = await drProxPractitionerApiInstance.put<IBasicCodeMessageResponse>(endpoint);
    return response.data;
}

/**
 * @deprecated
 */
export async function editPractitionerKCM(organizationId: number, email:string,  roles: string[], statusCode: string, token:string) {
    const endpoint = `organization/practitioner/${organizationId}/${email}?statusCode=${statusCode}`; 
    const response = await drProxPractitionerApiInstance.put<IBasicCodeMessageResponse>(endpoint,roles, {headers: {Authorization: `Bearer ${token}`}});
    return response.data;
}

export function getOfficesTreeByOrganization(languageCode: string, organizationId: number) {
    return axiosApiInstance.get(
        `${generateUrl()}/drproxservices/structure/organization/${organizationId}/${languageCode}`,
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as OfficeByOrganization[];
    });
}

/**
 * @deprecated
 */
export function getPractitionersTreeByOrganization(languageCode: string, organizationId: number) {
    return axiosApiInstance.get(
        `${generateUrl()}/drproxservices/structure/organization/practitioner/${organizationId}/${languageCode}`,
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as PractitionerByService[];
    });
}

export async function getOrganizationPractitioners(organizationId: number): Promise<PractitionerData[]>
{
    const endpoint = `/api/v1/organization/structure/practitioners/${organizationId}`;
    const response = await drpServicesServiceApiInstance.get<PractitionerData[]>(endpoint);
    return response.data;
}

export function relatePractitionerAndService(serviceInfo: {organizationId: number, proxServiceLeafId: number}, usernameList: string, appOrigin: string) {    
    return axiosApiInstance.post(
        `${generateUrl()}/drproxservices/structure/consulting-room/service/practitioner/?appOrigin=${appOrigin}&${usernameList}`,
        serviceInfo
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as IBasicCodeMessageResponse;
    });
}

export function relateServicesAndPractitioner(serviceInfo: {organizationId: number, nestedOrganizationStructureId: number, servicesIds: number[], username: string}) {    
    return axiosApiInstance.post(
        `${generateUrl()}/drproxservices/structure/consulting-room/service/`,
        serviceInfo
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as IBasicCodeMessageResponse;
    });
}

export function resendPractitionerInvitation(
    invitation: {
        email: string,
        languageCode: string,
        organizationName: string,
        templateCode: string,
        url: string,
        userName: string
        appOrigin:string
    }
) {
    return axiosApiInstance.post(
        `${generateUrl()}/notification/organization/email/drprox/invitation`,
        invitation
    ).then(data => {
        const practitioners = data.data as unknown;
        return practitioners as IBasicCodeMessageResponse;
    });
}

export async function getPractitionersByService(officeId : string, serviceCode: string) {
    const url = `${generateUrl()}/drproxservices/api/v1/organization/structure/practitioners/${officeId}/${serviceCode}`;
    const response = await axiosApiInstance.get(url);
    return response.data;
}
export async function getPractitionersByServiceId(officeId : string, serviceId: string) {
    const url = `${generateUrl()}/drproxservices/api/v1/organization/structure/practitioners/service/${officeId}/${serviceId}`;
    const response = await axiosApiInstance.get(url);
    return response.data;
}

export async function assignPractitionersToService(request : { officeId: string, organizationId: number, serviceId: string, practitionersUsername: string[]}) {
    console.log("assignPractitionersToService request", request);
    const url = `${generateUrl()}/drproxservices/api/v1/organization/structure/practitioner/service`;
    return await axiosApiInstance.post(url, request).then(data => {
        const response = data.data as unknown;
        return response as { code: string, message: string, status: string, error: string };
    });
}